/**
 * The editor's heading and its Form / YAML switch. The heading takes focus
 * when the editor opens on the viewer's own action (`focusOnShow`), so a
 * keyboard or phone user lands in the editor (below the list, on a stacked
 * phone layout) instead of on <body>.
 */

import { useEffect, useRef, type ReactElement } from 'react';

interface DefinitionEditorHeaderProps {
  title: string;
  view: 'yaml' | 'form';
  formDisabled: boolean;
  yamlDisabled: boolean;
  focusOnShow: boolean;
  onForm: () => void;
  onYaml: () => void;
}

export function DefinitionEditorHeader(props: DefinitionEditorHeaderProps): ReactElement {
  const heading = useRef<HTMLHeadingElement>(null);
  const focusOnMount = useRef(props.focusOnShow);
  useEffect(() => {
    if (focusOnMount.current) heading.current?.focus();
  }, []);
  return (
    <div className="def-editor__header">
      <h3 className="def-detail__name" ref={heading} tabIndex={-1}>{props.title}</h3>
      <div className="def-editor__views" role="group" aria-label="Editor view">
        <button
          type="button"
          className="secondary-button"
          aria-pressed={props.view === 'form'}
          disabled={props.formDisabled}
          onClick={props.onForm}
        >
          Form
        </button>
        <button
          type="button"
          className="secondary-button"
          aria-pressed={props.view === 'yaml'}
          disabled={props.yamlDisabled}
          onClick={props.onYaml}
        >
          YAML
        </button>
      </div>
    </div>
  );
}
